import { Controller } from '@hotwired/stimulus';
import { find } from '@fretadao/f-js-dom';
import { application } from 'src';
import { API } from 'src/api';

application.register(
  'line-transfers-panel',
  class extends Controller {
    static targets = ['dateFilter', 'optionsButton', 'table'];
    static values = { lineId: Number, slug: String };

    appliedQuery = {};

    connect() {
      this.makeRequest()
    }

    makeRequest(event) {
      if (!this.hasLineIdValue) return;

      if (event && event.params && event.params.order) this.appliedQuery.order = event.params.order;
      if (event && event.params && event.params.plan) this.appliedQuery.plan = event.params.plan;

      this.appliedQuery.date = find('[data-filter-date]').dataset.filterDate;

      API.busOperatorLineTransfer.getTable(this.slugValue, this.lineIdValue, this.#queryObjToString())
        .then((res) => this.tableTarget.innerHTML = res.data )
        .catch((error) => console.error(error))
    }

    #queryObjToString() {
      return new URLSearchParams(this.appliedQuery).toString();
    }
  }
);
